import { render, staticRenderFns } from "./UserAddReport.vue?vue&type=template&id=c0bc775e&scoped=true"
import script from "./UserAddReport.vue?vue&type=script&lang=js"
export * from "./UserAddReport.vue?vue&type=script&lang=js"
import style0 from "./UserAddReport.vue?vue&type=style&index=0&id=c0bc775e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bc775e",
  null
  
)

export default component.exports